import React from 'react';
import './Card.css';

export interface CardProps {
  details: CardDetails | undefined
  clear: React.Dispatch<React.SetStateAction<CardDetails | undefined>>
}

export interface CardDetails {
  name: string;
  description?: string;
  choices: CardDetails[];
}

function Card(props: CardProps) {

  const renderCardBody = () => {
    if (props.details) {
      return (
        <div className="card bg-light mb-3" onClick={() => props.clear(undefined)}>
          <div className="card-glass-pane"/>
          <div className="card-header">{props.details.name}</div>
          <div className="card-body">
            {props.details.description ?
              <p className="card-text"
                 dangerouslySetInnerHTML={{__html: props.details.description}}/> : ""}
            {props.details.choices.map((c, i) =>
              <div key={i} className="card-choice">
                <span className="card-choice-name">{c.name + ": "}</span>
                <span className="card-choice-text"
                      dangerouslySetInnerHTML={{__html: c.description ? c.description : ""}}/>
              </div>)}
          </div>
        </div>
      )
    }
  }

  return (
    <div className={"form-description"}>
      {renderCardBody()}
    </div>
  )

}

export default Card;